<template>
    <div class="w-100 h-100 d-flex flex-column">
        <b-form-select class="w-100 mb-1" :options="selectType"
                       v-model="type"></b-form-select>
        <template v-if="type === 'enum'">
            <b-button class="w-100" variant="light" @click="openModal">设置选项</b-button>
            <div v-for="item of fixedOptions" :key="item.value">
                {{ item.value }}:{{ item.text }}
            </div>
        </template>
        <template v-if="type === 'from_dict'">
            <b-form-input v-model="from" debounce="300"></b-form-input>
        </template>

        <re-b-modal ref="enum" header="Select Enum">
            <mini-table read-only
                        :items="options"
                        :fields="optionEditField"
                        row-key="value"
                        effect-origin-row
                        enable-inline-edit>
                <template #leftHeader>
                    <mini-button @btnClick="openEnumImport">
                        <i class="fa-solid fa-download"></i>
                    </mini-button>
                </template>
                <template #rightHeader>
                    <b-dropdown text="Quick Set" variant="light">
                        <b-dropdown-item v-for="(item,i) of quickSet" :key="i"
                                         @click="options = deepCopyObj(item)">
                            {{ item }}
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </mini-table>
        </re-b-modal>

        <re-b-modal ref="enumImport" header="Import Enum"
                    ok-label="Import"
                    @ok="importFromEnum">
            <mini-input :value.sync="enumName" type="input" label="Enum Class Name"/>
            <b-button variant="light" class="mt-1" @click="queryEnum">
                Search
            </b-button>
            <div>
                {{ enumMap }}
            </div>
        </re-b-modal>
    </div>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import MiniInput from "@/components/common/inputs/MiniInput.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "SelectConfig",
    components: {MiniInput, MiniButton, MiniTable, ReBModal},
    mixins: [emCommonUtilMixin],
    props: {
        item: Object
    },
    data() {
        return {
            selectType: [
                {value: null, text: 'Please select type'},
                {value: 'enum', text: 'Static'},
                // {value: 'from_entity', text: 'From Entity'},
                {value: 'from_dict', text: 'Dict Enum'},
            ],
            type: null,
            options: [],
            optionEditField: [
                {key: 'value', label: 'Value', type: 'input'},
                {key: 'text', label: 'Label', type: 'input'},
            ],
            from: null,

            enumName: null,
            enumMap: {},

            quickSet: [
                [{value: 'true', text: '是'}, {value: 'false', text: '否'},],
                [{value: '1', text: '是'}, {value: '0', text: '否'},]
            ]
        }
    },
    computed: {
        fixedOptions() {
            let tempList = [];
            for (let item of this.options) {
                tempList.push({
                    value: item.value,
                    text: item.text
                })
            }
            return tempList;
        },
    },
    watch: {
        item: {
            handler(val, old) {
                if (val && (!old || val.key !== old.key)) {
                    if (this.item.optionsFromDict) {
                        this.type = 'from_dict';
                        this.from = this.item.optionsFromDict;
                    }
                    if (this.item.options) {
                        this.type = 'enum';
                        this.options = this.item.options;
                    }
                }
            },
            immediate: true
        },
        fixedOptions() {
            if (this.type === 'enum') {
                this.$set(this.item, 'options', this.fixedOptions);
                this.$set(this.item, 'optionsFromDict', undefined);
            }
        },
        from: {
            handler() {
                if (this.type === 'from_dict') {
                    this.$set(this.item, 'options', undefined);
                    this.$set(this.item, 'optionsFromDict', this.from);
                }
            },
            immediate: true,
            deep: true
        },
    },
    methods: {
        openModal() {
            this.$refs.enum.showModal();
        },
        openEnumImport() {
            this.$refs.enumImport.showModal();
        },
        queryEnum() {
            let service = this.$store.state.queryConfigStore.currentService;
            if (service && this.enumName) {
                this.$store.dispatch('api/get', {
                    url: `${process.env.VUE_APP_EM_GATEWAY_URL}/${service}/qg/get/enum?enumClass=${this.enumName}`
                }).then(res => {
                    if (res) {
                        this.enumMap = res;
                    }
                });
            }
        },
        importFromEnum() {
            if (this.enumMap) {
                for (let key of Object.keys(this.enumMap)) {
                    this.options.push({
                        value: key,
                        text: this.enumMap[key]
                    })
                }
            }
        },
    }
}
</script>

<style scoped>

</style>
